import { render, staticRenderFns } from "./InqMember_M.vue?vue&type=template&id=54d94a40&scoped=true&"
import script from "./InqMember_M.vue?vue&type=script&lang=js&"
export * from "./InqMember_M.vue?vue&type=script&lang=js&"
import style0 from "./InqMember_M.vue?vue&type=style&index=0&id=54d94a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d94a40",
  null
  
)

component.options.__file = "InqMember_M.vue"
export default component.exports